"use strict";
/**
 * Use
 * npx onchange 'src/** /*.ts' -- yarn typedoc --excludePrivate --stripInternal --mode modules --excludeNotExported
 * to generate docs
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeAmy = exports.getAmy = exports.amyConfigs = exports.StudentAssignment = exports.Courses = exports.Amy = void 0;
const Amy_1 = require("./Amy");
exports.Amy = __importStar(require("./Amy"));
exports.Courses = __importStar(require("./Course"));
exports.StudentAssignment = __importStar(require("./StudentAssignment"));
const amyInstances = new Map();
/**
 * Returns an already initialized Amy instance.s
 * If you have multiple instances you should use the name of your instance
 * if you have only one instance, this command will return the only
 * instance available
 * @param name Name of the amy instance
 * @returns
 *
 *
 * ## Example
 *
 * ```typescript
 * import { getAmy } from "@amy-app/amy-app-js-sdk";
 * const amy = getAmy("amy.app")
 * ```
 *
 * ### Warning
 * This is NOT webworker (thread) save.
 */
function getAmy(name) {
    if (amyInstances.size === 0) {
        return undefined;
    }
    if (!name) {
        return Array.from(amyInstances.values())[0];
    }
    return amyInstances.get(name);
}
exports.getAmy = getAmy;
/**
 * Initializes an instance of an amy.app.
 * @param options
 */
function initializeAmy(options) {
    if (!amyInstances.has(options.firebaseApp.name)) {
        amyInstances.set(options.firebaseApp.name, new Amy_1.Amy({
            firebaseApp: options.firebaseApp,
        }));
    }
    return amyInstances.get(options.firebaseApp.name);
}
exports.initializeAmy = initializeAmy;
const amyConfigs = {
    apiKey: "AIzaSyC9ttADyEm-cfPb__joYv3MgBGjWOkxwMc",
    projectId: "amy--app",
    databaseURL: "https://amy--app.firebaseio.com",
    storageBucket: "amy--app.appspot.com",
    appId: "1:344535742053:web:a3298943d3d6171f0af88c",
};
exports.amyConfigs = amyConfigs;
//# sourceMappingURL=index.js.map